import { atLeastHalfOfElementInViewport } from '../visibility';

/**
 * This is set to be fetch because the implementation of onLoadBeacon might change
 * but it is clearer in the code what's supposed to happen and why
 */
const setOnLoadBeacon = fetch;

/**
 * Check if an element becomes and stays visible for at least 500ms before
 * firing onViewBeacon so that quick scrolling is inhibited in firing of events
 * @param {HTMLElement} target the HTMLElement to be observed
 * @param {string} url the onViewBeacon url
 */
const setOnViewBeacon = ({ target, url }) => {
    if (!target || !url) return;
    let timeoutId;
    const observer = new IntersectionObserver(
        (entries, obsrvr) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !timeoutId) {
                    timeoutId = setTimeout(() => {
                        if (atLeastHalfOfElementInViewport(entry.target)) {
                            fetch(url);
                            obsrvr.unobserve(target);
                        }
                        timeoutId = undefined;
                    }, 500);
                }
            });
        },
        { threshold: 0.5 }
    );
    observer.observe(target);
};

/**
 * If the Wishlist-Heart is being clicked, send request to url
 * @param {HTMLElement} target the HTMLElement to be observed
 * @param {string} url the onViewBeacon url
 */
const setOnWishlistBeacon = ({ target, url }) => {
    const formBtn = target.querySelector('button.js-wishlist-heart');
    formBtn?.addEventListener('click', () => {
        setOnLoadBeacon(url);
    });
};

export { setOnLoadBeacon, setOnViewBeacon, setOnWishlistBeacon };
